






import Vue from 'vue'
import { Component } from 'vue-property-decorator'

@Component
export default class ComponentSwitchWrapper extends Vue {
  active = false

  get is() {
    return this.$attrs.is || 'div'
  }

  setActive(state: boolean) {
    this.active = state
  }
}
